import gsap from 'gsap';
import { SECTIONS_IDS } from 'constants/global';

export const rulesAnimation = () => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `#${SECTIONS_IDS.rules}`,
      end: '+=700',
      scrub: true,
      pin: true,
      pinSpacing: 'padding',
      invalidateOnRefresh: true,
    },
  });

  tl.to('#rules-main-text', { yPercent: -20, opacity: 0 });
  tl.fromTo('#rules-subtext', { yPercent: 20, opacity: 0 }, { yPercent: 0, opacity: 1 });
};
